<template>
    <div>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="500px">
          <v-card color= "grey lighten-5">
            <v-flex xs12 sm12>
              <v-toolbar  size="120px" dark color="info">
                <v-toolbar-title >{{dialog_baslik}}</v-toolbar-title>
              </v-toolbar>
            </v-flex>
            <v-card-text>
              <v-container  grid-list-md>
                <v-layout  wrap>

                         <div class="flex md12">

                    <v-text-field v-show="addgib" label="Gib Seri"     v-model="Gib.Seri" :error-messages="errors.collect('gibseri')" v-validate="'required|max:3'"
                      data-vv-name="gibseri" required>
                    </v-text-field>

                    <v-switch label="Gib serisi pasif yap" v-model="Gib.Pasif"  color="orange darken-3"></v-switch>
                         </div>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div v-show="m === true">
                <v-btn id="bguncelle" color="blue darken-1" flat @click="guncelle()">Güncelle</v-btn>
                <v-btn id="bsil" color="blue darken-1" flat @click="deletegib()">Sİl</v-btn>
              </div>

              <v-btn color="blue darken-1" flat @click="vazgec()">Vazgeç</v-btn>
                <div v-show="k === true">
                <v-btn id="bkaydet" color="blue darken-1" flat @click="Kaydet()">Kaydet</v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-layout row wrap>
        <v-toolbar  size="120px" dark color="info">
          <v-toolbar-title >GİB Serisi Tanımlama</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field>
          <v-btn hidden="xs" flat @click="gibekle()"> GİB Ekle
            <v-icon right dark>add_box</v-icon>
          </v-btn>
        </v-toolbar>
      </v-layout>

      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>

        </v-card-title>
        <v-data-table :headers="headers" :rows-per-page-items=[50,100]  :loading="progress" :items="items" :search="search3">
                    <v-progress-linear slot="progress"   indeterminate></v-progress-linear>

          <template slot="items" slot-scope="props">
            <tr @click="Getir(props.item.Seri)" item>
              <td class="text-xs-left">{{ props.item.GibSeriID }}</td>
              <td class="text-xs-left">{{ props.item.Seri }}</td>
              <td class="text-xs-left">{{ props.item.Pasif }}</td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
          </v-alert>
        </v-data-table>
      </v-card>

      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-card>
      </template>
    </div>
</template>


<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        headers: [{
            text: 'Gib Seri İd',
            value: 'GibSeriID'
          },
          {
            text: 'Seri ',
            value: 'Seri'
          },
           {
            text: 'Pasif ',
            value: 'Pasif'
          }



        ],
        loading: false,
        items: [],
        search3: '',
        search: null,
        select: [],
        selected: '',
        m: false,
        k: false,
        dialog: false,
        addgib:false,
  Gib:{

  CompanyCode:'',
    GibSeriID:'',
    Seri:'',
    Pasif:false,
    GonderimSekli:false

  },
        state: [],
        progress:false,
        dialog_baslik: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        text1: '',
        bankakod: '',
        bankaadi: '',
        dictionary: {
          custom: {
            gibseri: {
              required: () => 'Bu alan boş bırakılamaz',
              max: () => 'Üç karakterden fazla olamaz'
            },
            sirketadi: {
              required: () => 'Bu alan boş bırakılamaz',
            }
          }
        }
      }
    },
    watch: {
      search(val) {
        val && this.carigetir(val)
      }
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
    },
    methods: {
      Getir(v) {
        this.k = false
        this.m = true
        this.$validator.reset()

        this.codegorunum = false
        this.dialog = true
        this.dialog_baslik = 'Gib Serisi Güncelle'
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params = {
          CompanyCode: credentials.SirketKodu,
          Serial:v
        }
        this.$http.post(auth.API_URL + 'api/Definitions/GibSerialLoad', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.Gib=response.body[0]

        })
      },
      deletegib: deletegib,
      gibekle: gibekle,
      Kaydet: Kaydet,
      guncelle: guncelle,
      vazgec: vazgec
    },
    beforeMount: beforeMount,
    vazgec: vazgec
  }


  function vazgec() {
    this.dialog = false
  }



  function Kaydet() {
 var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.$validator.validateAll().then((result) => {
      if (result) {
        var params = {
          CompanyCode: credentials.SirketKodu,
          Serial:this.Gib.Seri,
          Pasive:this.Gib.Pasif,
          SendType:this.Gib.GonderimSekli
        }
        this.$http.post(auth.API_URL + 'api/Definitions/GibSerialAdd', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true
          this.dialog = false
        var params1 = {
          CompanyCode: credentials.SirketKodu
        }
          this.$http.post(auth.API_URL + 'api/Definitions/GibSerialList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable.'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable.'
                this.snackbar = true
              }
            })
          })
}

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable.'
            this.snackbar = true
          }
        })
      }





  function gibekle() {

    this.dialog = true
    this.Gib = {}
    this.addgib=true
    this.dialog_baslik = 'Gib Serisi Ekle'
    this.m = false
    this.k = true
    this.$validator.reset()

  }

  function beforeMount() {
    this.progress=true
 var credentials = JSON.parse(window.localStorage.getItem('credentials'));

var params = {
  CompanyCode: credentials.SirketKodu
}

    this.$http.post(auth.API_URL + 'api/Definitions/GibSerialList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.items = response.body
      this.progress=false
    }, (response) => {
      if (response.status === 0) {
              this.progress=false

        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
              this.progress=false

        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }

  function deletegib() {

    this.addgib=false
    if (window.confirm('Şirket\'i silmek istediğinizden eminmisiniz?')) {
 var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      var params = {
        CompanyCode:  credentials.SirketKodu,
        Serial: this.Gib.Seri

      }
      this.$http.post(auth.API_URL + 'api/Definitions/GibSerialDelete', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (response.body.Status) {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true


              var params1 = {
                CompanyCode:credentials.SirketKodu
              }
          this.$http.post(auth.API_URL + 'api/Definitions/GibSerialList', params1, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
            this.items = response.body
            this.dialog = false

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable'
              this.snackbar = true
            } else {
               this.text1 = 'Service Unavailable'
              this.snackbar = true
            }
          })
        }
      }, (response) => {
        if (response.status === 0) {
             this.text1 = 'Service Unavailable'
              this.snackbar = true
        } else {
             this.text1 = 'Service Unavailable'
              this.snackbar = true
        }
      })
    }
  }

  function guncelle() {
    this.addgib=false

    this.$validator.validateAll().then((result) => {
      if (result) {
 var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
           CompanyCode: credentials.SirketKodu,
          Serial:this.Gib.Seri,
          GibSerialID:this.Gib.GibSeriID,
          Pasive:this.Gib.Pasif,
}

        this.codegorunum = false
        this.$http.post(auth.API_URL + 'api/Definitions/GibSerialUpdate', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          if (response.body.Status) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
              var credentials = JSON.parse(window.localStorage.getItem('credentials'));

              var params1 = {
                CompanyCode:credentials.SirketKodu
              }
            this.$http.post(auth.API_URL + 'api/Definitions/GibSerialList', params1, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              this.items = response.body
              this.dialog = false
            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
              } else {
                this.text1 = response.statusText
                this.snackbar = true
              }
            })
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = response.statusText
            this.snackbar = true
          }
        })
      }
    })
  }
</script>

<style>
</style>